import * as React from "react"
import type { SVGProps } from "react"
const SvgDeviceMobile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M7 23.57q-.82 0-1.41-.59A2 2 0 0 1 5 21.57v-18q0-.82.59-1.41A2 2 0 0 1 7 1.57h10q.83 0 1.41.59.6.59.59 1.41v18q0 .82-.59 1.41a2 2 0 0 1-1.41.59zm0-3v1h10v-1zm0-2h10v-12H7zm0-14h10v-1H7z" />
  </svg>
)
export default SvgDeviceMobile
